import { z } from 'zod';
import { isoDateSchema } from './common.js';

export const stageStatusSchema = z.enum([
  'not_started',
  'in_progress',
  'blocked',
  'completed',
]);
export type StageStatus = z.infer<typeof stageStatusSchema>;

export const workStageSchema = z.object({
  id: z.string(),
  projectId: z.string(),
  name: z.string(),
  description: z.string().nullable(),
  sortOrder: z.number().int(),
  status: stageStatusSchema,
  progressPercent: z.number().min(0).max(100),
  startDate: isoDateSchema.nullable(),
  endDate: isoDateSchema.nullable(),
  plannedStartDate: isoDateSchema.nullable(),
  plannedEndDate: isoDateSchema.nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type WorkStage = z.infer<typeof workStageSchema>;

export const createStageRequestSchema = z.object({
  name: z.string().trim().min(2).max(120),
  description: z.string().trim().max(1000).optional(),
  plannedStartDate: isoDateSchema.optional(),
  plannedEndDate: isoDateSchema.optional(),
  sortOrder: z.number().int().min(0).optional(),
});
export type CreateStageRequest = z.infer<typeof createStageRequestSchema>;

export const updateStageRequestSchema = z.object({
  name: z.string().trim().min(2).max(120).optional(),
  description: z.string().trim().max(1000).optional(),
  status: stageStatusSchema.optional(),
  progressPercent: z.number().int().min(0).max(100).optional(),
  startDate: isoDateSchema.optional(),
  endDate: isoDateSchema.optional(),
  plannedStartDate: isoDateSchema.optional(),
  plannedEndDate: isoDateSchema.optional(),
  sortOrder: z.number().int().min(0).optional(),
});
export type UpdateStageRequest = z.infer<typeof updateStageRequestSchema>;

export const reorderStagesRequestSchema = z.object({
  order: z
    .array(z.object({ id: z.string(), sortOrder: z.number().int().min(0) }))
    .min(1)
    .max(200),
});
export type ReorderStagesRequest = z.infer<typeof reorderStagesRequestSchema>;
